import { db } from './firebase';
import { doc, getDoc, setDoc, increment, arrayUnion, runTransaction } from 'firebase/firestore';

export const statsService = {
  getUserStats: async (userId) => {
    const ref = doc(db, 'users', userId);
    const snap = await getDoc(ref);
    if (snap.exists()) return snap.data();

    const initial = {
      totalGames: 0,
      maxScore: 0,
      totalScore: 0,
      totalWords: 0,
      totalPasses: 0,
      totalWrong: 0,
      fastestWordMs: null,
      scoreHistory: [],
    };
    await setDoc(ref, initial);
    return initial;
  },

  saveGameResult: async (userId, gameData) => {
    const ref = doc(db, 'users', userId);

    const entry = {
      score: gameData.score || 0,
      wordsGuessed: gameData.wordsGuessed || 0,
      wrongAnswers: gameData.wrongAnswers || 0,
      passesUsed: gameData.passesUsed || 0,
      wordsHistory: gameData.wordsHistory || [],
      mode: gameData.mode || 'local',
      date: new Date().toISOString(),
    };

    await runTransaction(db, async (transaction) => {
      const snap = await transaction.get(ref);
      const cur = snap.exists() ? snap.data() : { maxScore: 0, fastestWordMs: null };

      const newMax = Math.max(cur.maxScore || 0, gameData.score || 0);
      const newFastest =
        gameData.fastestWordMs != null &&
        (cur.fastestWordMs === null || gameData.fastestWordMs < cur.fastestWordMs)
          ? gameData.fastestWordMs
          : cur.fastestWordMs;

      transaction.set(
        ref,
        {
          totalGames: increment(1),
          totalScore: increment(gameData.score || 0),
          totalWords: increment(gameData.wordsGuessed || 0),
          totalPasses: increment(gameData.passesUsed || 0),
          totalWrong: increment(gameData.wrongAnswers || 0),
          maxScore: newMax,
          fastestWordMs: newFastest ?? null,
          scoreHistory: arrayUnion(entry),
        },
        { merge: true },
      );
    });
  },

  getTeamStats: async (teamId) => {
    // Aggregate stats for all team members
    const teamRef = doc(db, 'teams', teamId);
    const teamSnap = await getDoc(teamRef);
    if (!teamSnap.exists()) return null;
    const members = teamSnap.data().members || [];

    const allStats = await Promise.all(members.map((m) => statsService.getUserStats(m.userId)));
    return {
      totalGames: allStats.reduce((s, u) => s + (u.totalGames || 0), 0),
      totalScore: allStats.reduce((s, u) => s + (u.totalScore || 0), 0),
      totalWords: allStats.reduce((s, u) => s + (u.totalWords || 0), 0),
      maxScore: Math.max(...allStats.map((u) => u.maxScore || 0)),
      memberStats: allStats,
    };
  },
};
